import React from "react";
import { Chip, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const useStyles = makeStyles()((theme) => ({
  multiSelectTextCounterWithTooltipInput: {
    position: "relative",
    height: theme.custom.denseButtonHeight
  },
  multiSelectTextCounterWithTooltip: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    height: "100%",
    width: "100%"
  },
  multiSelectTextCounterWithTooltipBody: {
    maxWidth: "400px",
    maxHeight: "300px",
    overflowY: "auto"
  },
  multiSelectTextCounterWithTooltipTitle: {
    display: "flex",
    gap: theme.spacing(0.5)
  },
  multiSelectTextCounterWithTooltipList: {
    marginTop: theme.spacing(1.75),
    display: "inline-flex",
    flexWrap: "wrap",
    rowGap: theme.spacing(1.25),
    columnGap: theme.spacing(0.75)
  },
  multiSelectTextCounterWithTooltipLabel: {
    textOverflow: "ellipsis",
    overflowX: "hidden",
    maxWidth: "100px"
  },
  multiSelectTextCounterWithTooltipFilterLabel: {
    marginRight: theme.spacing(1.25),
    color: theme.palette.secondary.main,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));
function MultiSelectTextCounterWithTooltip({
  label,
  tooltipTitle,
  selectedTotal,
  values,
  element,
  filterLabel,
  color
}) {
  const { classes } = useStyles();
  const maxValuesCount = 200;
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      placement: "bottom-start",
      title: /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltipBody }, /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltipTitle }, /* @__PURE__ */ React.createElement(LocalizedText, { label: tooltipTitle }), /* @__PURE__ */ React.createElement(Chip, { label: selectedTotal, size: "small" })), values?.length ? /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltipList }, values.slice(0, maxValuesCount).map((value) => /* @__PURE__ */ React.createElement(Chip, { label: /* @__PURE__ */ React.createElement(LocalizedText, { label: value }), size: "small" })), selectedTotal > maxValuesCount ? /* @__PURE__ */ React.createElement(Chip, { label: "...", size: "small" }) : null) : null),
      element: element ? /* @__PURE__ */ React.createElement("div", null, element) : /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltipInput }, /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltip }, /* @__PURE__ */ React.createElement(Chip, { label: selectedTotal, size: "small", color }), filterLabel ? /* @__PURE__ */ React.createElement(
        Typography,
        {
          variant: "body1",
          className: classes.multiSelectTextCounterWithTooltipFilterLabel,
          component: "span"
        },
        /* @__PURE__ */ React.createElement(LocalizedText, { label: filterLabel })
      ) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectTextCounterWithTooltipLabel }, /* @__PURE__ */ React.createElement(LocalizedText, { label: label ?? values?.join(", ") }))))
    }
  );
}
export {
  MultiSelectTextCounterWithTooltip
};
//# sourceMappingURL=MultiSelectTextCounterWithTooltip.js.map
